import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.LINK_ORDER_PACKAGE.REQUEST, saga.linkOrderPackage);
    yield takeLatest(ACTION.LINK_ORDER_PACKAGE.SUCCESS, saga.onLinkOrderPackageSuccess);
    yield takeLatest(ACTION.LINK_ORDER_PACKAGE.FAILED, saga.onLinkOrderPackageFailed);
}
